import { Schema } from 'effect';

/**
 * One letter or digit — the domain of every `?alphabet=` listing filter
 * (brands, glossary). Anything longer or outside the set is not a value the
 * backend filter accepts, so it decodes as absent rather than as a filter that
 * would be rejected.
 *
 * The set is Unicode, not ASCII. The backend filters on the literal first
 * character of a name (`LOWER(SUBSTRING(name,1,1)) = LOWER(:letter)`) under a
 * deterministic PostgreSQL collation, where `č` is a distinct character from
 * `c`. Native Czech and Slovak initials are therefore listings of their own,
 * and a filter restricted to `a–z` could never reach them.
 *
 * Casing is not normalized here. The backend lowercases both sides of that
 * comparison, so either case selects the same listing, and the alphabet
 * endpoint's own values are the ones guaranteed to match — re-casing what it
 * reported could only break the round trip. Consumers fold case when matching a
 * value to a tile (`sameAlphabetValue`), not when carrying it.
 */
export const AlphabetFilterSchema = Schema.String.check(
  Schema.isPattern(/^[\p{L}\p{N}]$/u)
).annotate({
  identifier: 'AlphabetFilterSchema',
  description: 'Single Unicode letter or digit for alphabet filtering',
});
